<template>
  <div class="ossStatsData-container app-container">
    <div class="ossStatsData-header bg-white">
      <div class="ossStatsData-header-bottom">
        <div class="ossStatsData-header-bottom-date">
          <div class="booxCloud-date-select">
            <span
              v-for="item in dateType"
              :key="item.type"
              class="booxCloud-date-select-item"
              :class="{
                'booxCloud-date-select-active': type === item.type,
              }"
              @click="changeType(item.type)"
              >{{ item.label }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="ossStatsData-main" v-bar>
      <div>
        <template v-if="storageData">
          <OssStorageLineChart
            v-for="(chartData, index) in storageData"
            :key="index"
            :chartData="chartData"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import OssStorageLineChart from "./components/ossStorageLineChart";
export default {
  components: {
    OssStorageLineChart,
  },
  data() {
    return {
      ossBuckets: ["onyx-cloud", "onyx-cloud-eu", "onyx-cloud-us"],
      storageData: null,
      type: "day",
      area: "users-prod",
      params: {
        type: "day",
      },
      areaType: [
        {
          type: "users-prod",
          label: "国内",
        },
        {
          type: "users-us",
          label: "国外",
        },
      ],
      dateType: [
        {
          type: "day",
          label: "天",
        },
        {
          type: "week",
          label: "周",
        },
        {
          type: "month",
          label: "月",
        },
        {
          type: "year",
          label: "年",
        },
      ],
    };
  },
  methods: {
    changeType(type) {
      if (this.type === type) return;
      this.type = type;
      this.params.type = type;
      this.getStorageByDate();
    },
    changeAreaType(type) {
      if (this.area === type) return;
      this.area = type;
      // this.getStorageByDate();
    },

    async getStorageByDate() {
      try {
        this.storageData = [];
        for (let bucket of this.ossBuckets) {
          this.params.bucket = bucket;
          let res = await this.$http.getOssStatsData(this.params);
          this.storageData = [...this.storageData, res.data];
        }
      } catch (error) {
        throw error;
      }
    },
  },
  mounted() {
    this.getStorageByDate();
  },
};
</script>

<style lang="scss">
.ossStatsData-container {
  .ossStatsData-header {
    padding: 10px 50px;
    .ossStatsData-header-top {
      display: flex;
      justify-content: space-around;
      padding: 20px 0 30px;
      border-bottom: 1px solid $globalBorderColor;
    }
    .ossStatsData-header-bottom {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
      .ossStatsData-header-bottom-date {
        display: flex;
        align-items: center;
        .booxCloud-date-select {
          .booxCloud-date-select-item {
            display: inline-block;
            padding: 6px 12px;
            margin-left: 20px;
            font-size: 14px;
            border-radius: 4px;
            border: none;
            outline: none;
            cursor: pointer;
            -webkit-transition: all 0.3s;
            transition: all 0.3s;
            background: #ccc;
            color: #fff;
          }
          .booxCloud-date-select-active {
            background: #bf735b;
            color: #fff;
          }
        }
      }
    }
  }
  .booxCloud-date-select {
    .booxCloud-date-select-item {
      display: inline-block;
      padding: 6px 12px;
      margin-left: 20px;
      font-size: 14px;
      border-radius: 4px;
      border: none;
      outline: none;
      cursor: pointer;
      -webkit-transition: all 0.3s;
      transition: all 0.3s;
      background: #ccc;
      color: #fff;
    }
    .booxCloud-date-select-active {
      background: #bf735b;
      color: #fff;
    }
  }
  .ossStatsData-main {
    flex: 1;
    padding: 20px;
    overflow: hidden;
  }
}
</style>
